import { Grid, TextField } from "@mui/material";
import { useEffect, useState, React } from "react";
import { useSelector } from "react-redux";

function TextFieldEmail(processText) {
    const { registerErrors } = useSelector((state) => state.auth);
    const { currentUser } = useSelector((state) => state.auth);
    const perpetualUser = useSelector((state) => state.dashboard.boards);
    const [signupDisabled, setDisabled] = useState(true);
    const [textValue, setTextValue] = useState("");

    function updateValue(value) {
        setTextValue(value);
        processText("email", value);
    }

    const handleChange = (e) => {
        e.preventDefault();
    };

    useEffect(() => {
        let disabled = false;
        if (currentUser !== null && currentUser !== undefined) {
            setTextValue(currentUser.email);
            if (currentUser.balanc === 0) {
                if (perpetualUser.length > 0) {
                    for (let i = 0; i < perpetualUser.length; i += 1) {
                        if (perpetualUser[i].board !== undefined) {
                            if (perpetualUser[i].board !== null) {
                                disabled = true;
                                break;
                            }
                        }
                    }
                }
            } else {
                disabled = true;
            }
        }
        setDisabled(disabled);
    }, [currentUser, perpetualUser]);

    return (
        <Grid item xs={12} style={{ margin: "10px" }}>
            <TextField
                error={
                    registerErrors && registerErrors.email !== null
                        ? registerErrors.email
                        : null
                }
                helperText={
                    registerErrors && registerErrors.email !== null
                        ? registerErrors.email
                        : null
                }
                id="outlined-email-input"
                onCut={handleChange}
                onCopy={handleChange}
                onPaste={handleChange}
                label="Email"
                type="text"
                autoComplete="email"
                onChange={(e) => updateValue(e.target.value)}
                value={textValue}
                disabled={signupDisabled}
            />
        </Grid>
    );
}

export default TextFieldEmail;
